module.exports = __webpack_public_path__ + "static/img/console_banner.e76ea31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/console_banner.png
// module id = Tg8z
// module chunks = 8